import React from "react";
import "./promo.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMedal} from "@fortawesome/free-solid-svg-icons";

const Penawaran = ({image, title, points, whatsapp = []}) => {
  // Default to an empty array for points

  return (
    <div id="promo" className="promosumbog">
      <div className="promo-sumbog">
        <div className="gambarpromo">
          <img src={image} alt="Promo" />
        </div>
        <div className="ket-promo">
          <div className="judul">
            <h1>{title}</h1>
          </div>
          <div className="promolist">
            <div className="pointpenawaran">
              {points.length > 0 ? (
                points.map((point, index) => (
                  <div className="penawaranpoin" key={index}>
                    <FontAwesomeIcon icon={faMedal} />
                    <span style={{color: "white"}}>&nbsp;&nbsp;{point}</span>
                  </div>
                ))
              ) : (
                <div>No promotional points available.</div> // Fallback message
              )}
            </div>
          </div>
          <button
            className="buttonpenawaran"
            onClick={() => window.open(whatsapp, "_blank")}>
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
